import { IPaymentData } from "common/records/Payment";
import { PaymentAuthorizationRecord } from "common/records/PaymentAuthorizationRecord";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_PAYMENT = "@patterns/RECEIVE_PAYMENT";
export const RECEIVE_PAYMENTS = "@patterns/RECEIVE_PAYMENTS";
export const MAKE_PAYMENT = "@payments/MAKE_PAYMENT";
export const FETCH_AUTHORIZED = "@payments/FETCH_AUTHORIZED";
export const RECEIVE_AUTHORIZED = "@payments/RECEIVE_AUTHORIZED";

export const PaymentActions = {
  receivePayment: (payment: Partial<IPaymentData>) => createAction(RECEIVE_PAYMENT, { payment }),
  receivePayments: (payments: Partial<IPaymentData>[]) => createAction(RECEIVE_PAYMENTS, { payments }),
  makePayment: () => createAction(MAKE_PAYMENT),
  fetchAuthorized: (orgId: number) => createAction(FETCH_AUTHORIZED, { orgId }),
  receiveAuthorized: (orgId: number, auth: PaymentAuthorizationRecord) =>
    createAction(RECEIVE_AUTHORIZED, { orgId, auth }),
};

export type PaymentActions = ActionsUnion<typeof PaymentActions>;
